module.exports = __webpack_public_path__ + "static/media/profile.125ab865.jpg";